"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var subElement = function subElement(type, theme, children) {
  switch (type) {
    case "title":
      {
        return /*#__PURE__*/_react["default"].createElement("div", {
          style: theme['title-content']
        }, /*#__PURE__*/_react["default"].createElement("h1", {
          style: theme['title']
        }, children));
      }

    case "sub-title":
      {
        return /*#__PURE__*/_react["default"].createElement("div", {
          style: theme['title-content']
        }, /*#__PURE__*/_react["default"].createElement("h2", {
          style: theme['sub-title']
        }, children));
      }

    default:
      {
        return /*#__PURE__*/_react["default"].createElement("div", {
          style: theme['text-content']
        }, children);
      }
  }
};

var TextComponent = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(TextComponent, _React$PureComponent);

  function TextComponent() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = TextComponent.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        type = _this$props.type,
        theme = _this$props.theme,
        children = _this$props.children;
    return subElement(type, theme, children);
  };

  return TextComponent;
}(_react["default"].PureComponent);

var _default = TextComponent;
exports["default"] = _default;
module.exports = exports.default;